export default __webpack_public_path__ + "static/media/amazon-com-logo.d6ec562f.svg";